import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const smartcardpage = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart/card/page',
    Object.assign({}, options, {
      params
    })
  );

export const smartcardsave = (params, options) =>
  request.post('/api/v4ward/nursinghome/smart/card/save', params, options);

  
export const smartcardrecharge = (params, options) =>
request.post('/api/v4ward/nursinghome/smart/card/recharge',  qs.stringify(params), options);

export const smartcardlogout = (params, options) =>
request.post('/api/v4ward/nursinghome/smart/card/logout',qs.stringify(params), options);
//账单分页
export const smartcardflowpage = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart/card/flow/page',
    Object.assign({}, options, {
      params
    })
  );
  export const smartcardflowstatistics = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart/card/flow/statistics',
    Object.assign({}, options, {
      params
    })
  );

  export const nursingbasicInforpage = (params, options) =>
  request.get(
    '/api/nursing/basicInfor/page',
    Object.assign({}, options, {
      params
    })
  );